import React from 'react'
import { Link } from "react-router-dom";


const Blog = () => {
    return (
        <>
            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2>Blog</h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}>Blog</li>
                    </ul>
                </div>
            </section>

            <section className="news-one" style={{ overflow: "hidden", marginTop: "-50px" }}>
                <div className="auto-container">
                    <div className="sec-title centered">
                        <h2 className="sec-title_heading">Blog Events</h2>
                        <p>Emergency admissions, patient care, hematological, radiological, and other investigations are all part of the 24-hour emergency services.</p>
                    </div>
                    <div className="row clearfix">
                        <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                            <div className="news-block_one-inner wow fadeInLeft" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                <div className="news-block_one-image">
                                    <Link to="/coronavirus-infections"><img src="assets/img/Coronavirus.webp" alt /></Link>
                                </div>
                                <div className="news-block_one-content">
                                    <div className="news-block_one-date"><span>22</span> jan. 2025</div>
                                    <h5 className="news-block_one-heading"><Link to="/coronavirus-infections">How to Prevent the Spread of Coronavirus Infections</Link></h5>
                                    {/* <div className="news-block_one-text">Nowadays, cancer is more than just a disease. However, it is a serious stage that has an impact on a person's finances, emotions, and physical health.</div> */}
                                    <Link style={{ textAlign: "center" }} className="department-one_block-two_more" to="/coronavirus-infections">read more</Link>
                                    {/* <div className="about-one_button"><a to="about.html" className="theme-btn btn-style-one"><span className="btn-wrap"><span className="text-one">Discover More</span><span className="text-two">Discover More</span></span></a></div> */}
                                </div>
                            </div>
                        </div>
                        <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                            <div className="news-block_one-inner wow fadeInUp" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                <div className="news-block_one-image">
                                    <Link to="/about-coronavirus"><img src="assets/img/corona.jpg" alt /></Link>
                                </div>
                                <div className="news-block_one-content">
                                    <div className="news-block_one-date"><span>16</span> Aug. 2025</div>
                                    <h5 className="news-block_one-heading"><Link to="/about-coronavirus">Everything You Should Know About Coronavirus</Link></h5>

                                    {/* <div className="news-block_one-text" style={{ textAlign: "" }}>The foundation of healthcare is trust. You need a reliable doctor for long-term care when a medical emergency occurs. We provide cutting-edge facilities, knowledgeable physicians, and reasonable costs. </div> */}
                                    <Link style={{ textAlign: "center" }} className="department-one_block-two_more mt-lg-4" to="/about-coronavirus">read more</Link>
                                </div>
                            </div>
                        </div>
                        <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                            <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                                <div className="news-block_one-image">
                                    <Link to="/urology-orthopedics"><img src="assets/img/05.jpg" alt /></Link>
                                </div>
                                <div className="news-block_one-content">
                                    <div className="news-block_one-date"><span>06</span> Nov. 2025</div>
                                    <h5 className="news-block_one-heading"><Link to="/urology-orthopedics">Satna's Leading Neurologist: For Brain & Beyond</Link></h5>
                                    <Link style={{ textAlign: "center" }} className="department-one_block-two_more" to="/urology-orthopedics">read more</Link>
                                    {/* <div className="news-block_one-text">A one-dimensional approach to health is never appropriate. As a result, you and your family ought to have access to a multispecialty hospital where all medical care is provided. </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Blog